var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { View } from 'react-native';
import { useDynamicSvgWeb } from '../../hooks';
import { getTestId } from '../../utils';
export var DynamicSvg = props => {
  if (!(props === null || props === void 0 ? void 0 : props.iconName) && !(props === null || props === void 0 ? void 0 : props.xml)) return null;
  var _a = useDynamicSvgWeb(props),
    xml = _a.xml,
    _a$testID = _a.testID,
    testID = _a$testID === void 0 ? 'DynamicSvg' : _a$testID,
    width = _a.width,
    height = _a.height,
    fontSize = _a.fontSize,
    style = _a.style,
    restProps = __rest(_a, ["xml", "testID", "width", "height", "fontSize", "style"]);
  var _width = width;
  var _height = height;
  if (fontSize) _width = fontSize, _height = fontSize;
  var commonStyles = {
    width: _width,
    height: _height,
    display: 'flex'
  };
  return _jsx(View, Object.assign({}, restProps, {
    style: [commonStyles, {
      alignItems: 'center',
      justifyContent: 'center'
    }, style]
  }, getTestId(testID), {
    children: !!xml && _jsx("span", {
      "aria-hidden": true,
      style: commonStyles,
      dangerouslySetInnerHTML: {
        __html: xml
      }
    })
  }));
};